import { IStressResponse } from '@toro/common/shared/interfaces/pos-risk/stress.interface';
import { Component, ViewChild, ElementRef, ChangeDetectorRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { DialogsService } from '@toro/common/shared/services/dialogs.service';
import { StockCardsComponent } from '../../../partials/stock-cards/stock-cards.component';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { ComputingParameter } from '@toro/common/shared/models/computing-parameter/computing-parameter.model';
import { Subscription } from 'rxjs/Subscription';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { KeyStocks } from '@toro/common/shared/enum/key-stocks/key-stocks.enum';
import { ComputerService } from '@toro/common/shared/services/computer/computer.service';
import { StockCheckoutType } from '@toro/common/shared/models/stocks-exchange/stock-checkout.model';
import { StocksExchangeCheckoutAction } from '../../../state-management/stocks-exchange-checkout/stocks-exchange-checkout.action';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { OrderSideEnum } from '@toro/common/shared/enum/orders/side.enum';
import { DialogDoneConfirmation } from '../../../partials/stock/dialogs/dialog-done-confirmation/dialog-done-confirmation.model';
import { DialogDoneConfirmationComponent } from '../../../partials/stock/dialogs/dialog-done-confirmation/dialog-done-confirmation.component';
import { OrderStatus } from '@toro/common/shared/enum/orders/order-status.enum';
import { ExchangeEffects } from '../../../state-management/exchange/exchange.effects';
import { ExchangeActions } from '../../../state-management/exchange/exchange.action';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { Order } from '@toro/common/shared/models/exchange/order.model';
import { OrderType } from '@toro/common/shared/enum/orders/order-type.enum';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { StocksMarketInteractionsService } from '../../../partials/stock/services/stocks-market-interactions.service';
import { ToastrService } from 'ngx-toastr';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { filter, first, map } from 'rxjs/operators';
import { timer } from 'rxjs';

const loadingTimeout = 12000;

@Component({
    selector: 'planned-card',
    templateUrl: './planned-card.component.html',
    styleUrls: ['./planned-card.component.scss'],
})
export class PlanedCardComponent extends StockCardsComponent {

    get instumentName(): string {
        return this.instrument ? this.instrument.descriptionStock : '';
    }

    get isPlanned(): boolean {
        return (this.stockDetails.strategyID || this.stockDetails.StrategyID) ? true : false;
    }

    @ViewChild('elementCard', { static: true }) public elementCard: ElementRef;
    @Input() public investType: any;
    @Input() public brokerageModel: number;

    public symbol: string;
    public symbolLogo: string;
    public symbolName: string;
    public unitPrice: number;
    public profitPotential: any = 0;
    public quote: any = null;
    public instrument: any = null;
    public pending: boolean = false;
    public stress: number = null;
    public secondaryStress: any = null;
    public sideEnum: any = OrderSideEnum;
    public pTaxValue: number = 0;
    public calculateParams: ComputingParameter = null;
    public marketScenario: number = null;
    public calculateScenario: number = null;
    public gainPrice: number = null;
    public lossPrice: number = null;
    public isFuture: boolean = false;
    public isDaytrade: boolean = false;
    public isBuy: boolean;
    public sideText: string;
    public amount: number;
    public guaranteeValue: number;
    public currentVariation: string;
    public gainValue: number;
    public lossValue: number;
    public currentResult: number;
    public resultValues: any = {};
    public pendingText: string;
    public redirectText: string;
    public buttonText: string;
    public pendingSideText: string;
    public loading: boolean;
    public isPtax: boolean;
    public legInput: Order;
    public legStopLoss: Order;
    public legStopGain: Order;
    public userCblc: number;
    public get closing(): boolean {
        return this.closingRequested || this.isClosingOnExchange();
    }

    public closeInvestmentDialog: MatDialogRef<DialogPanelComponentContent>;
    @Output() valueInvestedStackEvent = new EventEmitter<{}>();

    private closingRequested: boolean;
    private quoteSubscription: Subscription;
    private instrumentSubscription: Subscription;
    private stressSubscription: Subscription;
    private pTaxSubscription: Subscription;
    private closeStrategySuccessSubscription: Subscription;
    private cancelStrategySuccessSubsctiption: Subscription;
    private cancelStrategyErrorSubsctiption: Subscription;
    private marketOpen: boolean;
    private marketoOpeningTime: string;
    private loadingData: Subscription;

    constructor(
        protected router: Router,
        protected dialogServices: DialogsService,
        protected store: Store<AppState>,
        private computeService: ComputerService,
        private utilsService: UtilitiesService,
        protected changeDetectorRef: ChangeDetectorRef,
        private exchangeEffects: ExchangeEffects,
        public toastrService: ToastrService,
        private interactions: StocksMarketInteractionsService,
    ) {
        super(router, dialogServices, store, changeDetectorRef);
    }

    public ngOnInit() {

        this.isDaytrade = this.stockDetails.isDayTrade;
        this.symbol = this.stockDetails.symbol;
        this.pending = this.isPendingStatus(this.stockDetails.status);

        this.legInput = this.getLegByType(OrderType.Input);
        this.legStopGain = this.getLegByType(OrderType.StopGain);
        this.legStopLoss = this.getLegByType(OrderType.StopLoss);

        if (!this.legInput || !this.legStopLoss || !this.legStopGain) {
            const payloadLeg = {
                type: 'Investment not loaded',
                events: {
                    type: 'Missing legs',
                    legs: this.stockDetails,
                },
            };
            this.store.dispatch({ type: TrackingActions.trackEvents, payload: payloadLeg });
            return;
        }

        this.amount = this.legInput.orderQty;
        this.isBuy = this.legInput.side === OrderSideEnum.Compra;

        this.buttonText = this.pending ? 'Cancelar o pedido' : 'Encerrar agora';

        if (this.isBuy) {
            this.sideText = this.pending ? 'COMPRA' : 'COMPRADO';
            this.pendingText = 'TENTANDO COMPRAR NO MELHOR PREÇO DISPONÍVEL';
            this.redirectText = this.pending ? 'Editar compra' : 'Mais detalhes';
            this.pendingSideText = 'COMPRA PLANEJADA';
        } else {
            this.sideText = this.pending ? 'VENDA' : 'VENDIDO';
            this.pendingText = 'TENTANDO VENDER NO MELHOR PREÇO DISPONÍVEL';
            this.redirectText = this.pending ? 'Editar venda' : 'Mais detalhes';
            this.pendingSideText = 'VENDA PLANEJADA';
        }

        this.quoteSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((item) => this.stockDetails && item[this.symbol]),
                map((item) => item[this.symbol])
            )
            .subscribe((data) => {
                this.quote = data;
                if (this.quote.Stress) {
                    this.stress = this.quote.Stress.DayTradeStrategyValue;
                    this.secondaryStress = this.quote.Stress.Value;
                    this.isPtax = this.quote.Stress.IsPtax;
                }
                const price = this.quote.PriceLastTrade || this.quote.OpeningPrice || this.quote.ClosingPricePreviousDay;
                if (price != null)
                    this.unitPrice = price;
                this.calculateValues();
                
                if (this.instrument && this.instrument.code && this.currentResult && this.guaranteeValue) {
                    this.valueInvestedStackEvent.emit({ 
                        symbol: this.instrument.code, investedValue: this.currentResult + this.guaranteeValue
                    });
                }
            });

        this.instrumentSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.instruments)
            .pipe(
                filter((instrument) => this.stockDetails && instrument[this.symbol] ? true : false),
                map((instrument) => instrument[this.symbol]),
                first()
            )
            .subscribe((data) => {
                this.instrument = data;
                this.symbolLogo = this.instrument.logo.content;
                this.symbolName = this.instrument.descriptionStock;
                this.isFuture = this.instrument.typeMarket === OrderMarketTypeEnum.Future;
                this.stress = (this.instrument.stress as IStressResponse).dayTradeStrategyValue;
                this.secondaryStress = (this.instrument.stress as IStressResponse).value;
                this.isPtax = (this.instrument.stress as IStressResponse).isPtax;
                if (this.isPtax) {
                    this.store.dispatch({ type: StocksMarketAction.getQuote, payload: KeyStocks.DolPtax });
                }

                if(!this.unitPrice && this.instrument.priceLastTrade)
                    this.unitPrice = this.instrument.priceLastTrade;
                this.calculateValues();
            });

        this.pTaxSubscription = this.store.select((state) => state.stocksExchange.stocksMarket.quote)
            .pipe(
                filter((item) => this.stockDetails && item[KeyStocks.DolPtax]),
                map((item) => item[KeyStocks.DolPtax])
            )
            .subscribe((data) => {
                this.pTaxValue = data.PriceLastTrade || data.OpeningPrice || data.ClosingPricePreviousDay;
                this.calculateValues();
            });

        this.store.select((state) => state.authentication.currentUser)
            .pipe(
                filter(({cblc}) => !!cblc),
                first()
            )
            .subscribe(({cblc}) => {
                this.userCblc = cblc;
            });

        // Dispatch strategyStress
        this.store.dispatch({ type: StocksMarketAction.getQuote, payload: this.symbol });
        this.store.dispatch({ type: StocksMarketAction.getInstrumentInfo, payload: this.symbol });

        this.onHide.subscribe(() => {
            this.ngOnDestroy();
        });

        // Tracking de card não carregado
        this.loadingData = timer(loadingTimeout).pipe(
            filter(() => {
                return !Number.isFinite(this.guaranteeValue) || !Number.isFinite(this.currentResult);
            })
        ).subscribe(() => {
            this.trackUnableToLoadCardEvent();
        });
    }

    /**
     * Verifica e retorna as legs de um card
     */
    public getLegByType(legType: OrderType) {
        return this.stockDetails.legs.find((data) => {
            return data.internalOrderType === legType;
        });
    }

    /**
     * Verifica (a partir dos status da estratégia e legs se o exchange está encerrando a estratégia)
     */
    public isClosingOnExchange() {
        // Pernas não disponíveis
        if (!this.legInput || !this.legStopGain || !this.legStopLoss) {
            return false;
        }
        // Encerrando com perda
        const closingOnLoss = this.legStopLoss.status === OrderStatus.New && this.legStopGain.status === OrderStatus.Cancelled;
        // Encerrando com ganho
        const closingOnGain = this.legStopGain.status === OrderStatus.New && this.legStopLoss.status === OrderStatus.Cancelled;

        return (closingOnGain || closingOnLoss) && this.stockDetails.status === OrderStatus.New && this.legInput.status === OrderStatus.Filled;
    }

    public calculateValues() {
        if (!this.instrument || !this.stress) return;

        const guarantee = this.calculateGuarantee();
        const currentRawValue = this.calculateCurrentValue();

        if (!Number.isFinite(guarantee) || !Number.isFinite(currentRawValue)) return;

        this.currentVariation = this.getVariationText(currentRawValue);
        this.currentResult = Math.abs(currentRawValue) || 0;
        this.guaranteeValue = guarantee;
        this.gainValue = this.calculateGainValue();
        this.lossValue = this.calculateLossValue();

        this.resultValues = {
            gain: this.gainValue,
            loss: this.lossValue,
            variation: this.currentVariation,
            current: this.currentResult,
        };
    }

    public getVariationText(value: number) {
        if (!value || value === 0) return 'normal';

        return value > 0 ? 'high' : 'low';
    }

    /**
     * Calcula o valor da garantia
     */
    public calculateGuarantee() {
        if (!this.instrument || !this.stress) return 0;
        this.marketScenario = this.computeService.computeMarketScenario(this.instrument.typeMarket, this.isPtax);
        this.calculateScenario = this.computeService.computeCalculatingScenario(
            this.legInput.side === OrderSideEnum.Compra,
            this.isDaytrade,
            true,
        );
        const price = this.pending ? this.unitPrice : (this.legInput.avaragePriceExecuted || this.legInput.price);
        this.calculateParams = new ComputingParameter(
            this.amount,
            price,
            this.instrument.quoteFactor,
            this.stress,
            this.legStopLoss.priceTrigger,
            this.isPtax ? this.pTaxValue : null,
            this.secondaryStress,
        );
        return this.computeService.calculate(
            this.marketScenario,
            this.calculateScenario,
            this.calculateParams,
        ) || 0;
    }

    /**
     * Calcula o valor atual
     */
    public calculateCurrentValue() {
        const ptax = this.isPtax ? this.pTaxValue : null;
        const price = this.legInput.avaragePriceExecuted || this.legInput.price;
        const value = this.computeService.ComputeResultValue(
            this.amount,
            this.instrument.quoteFactor,
            this.unitPrice,
            price,
            this.isFuture,
            this.isBuy,
            ptax,
        );
        return Number.isFinite(value) ? value : NaN;
    }

    /**
     * Calcula o valor do Gain
     */
    public calculateGainValue() {
        const ptax = this.isPtax ? this.pTaxValue : null;
        const price = this.pending ? this.unitPrice : (this.legInput.avaragePriceExecuted || this.legInput.price);
        const value = this.computeService.ComputeStopValue(
            this.amount,
            this.instrument.quoteFactor,
            price,
            this.legStopGain.priceTrigger,
            this.isFuture,
            ptax,
        );
        return value || 0;
    }

    /**
     * Calcula o valor do Loss
     */
    public calculateLossValue() {
        const ptax = this.isPtax ? this.pTaxValue : null;
        const price = this.pending ? this.unitPrice : (this.legInput.avaragePriceExecuted || this.legInput.price);
        const value = this.computeService.ComputeStopValue(
            this.amount,
            this.instrument.quoteFactor,
            price,
            this.legStopLoss.priceTrigger,
            this.isFuture,
            ptax,
        );
        return value || 0;
    }

    public goToCheckout() {
        // tslint:disable-next-line: prefer-const
        let item = new StockCheckoutType();
        item.symbol = this.symbol;
        item.adviceId = this.stockDetails.id;
        this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item });
        this.router.navigate(['/checkout/planejado']);
    }

    public goToAnalyze() {
        const friendlyURL = this.utilsService.generateFriendlyURL(this.instrument.descriptionStock);
        this.router.navigateByUrl(`/analise/${this.symbol}-cotacao-${friendlyURL}`);
    }

    public ngOnDestroy() {
        if (this.closeInvestmentDialog) this.closeInvestmentDialog.close();
    }

    public ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    public buttonAction() {
        if (this.pending) {
            const side = (this.isBuy) ? 'compra' : 'venda';
            const title = `Cancelar a ${side}`;
            const message = `Cancelar a ${side} é uma ação que você não pode desfazer. Você tem certeza que deseja cancelar este pedido?`;
            this.openModalConfirm(title, message, 'Cancelar pedido', 'Voltar')
                .subscribe((result) => {
                    if (result) {
                        this.cancelStrategy();
                    }
                });
        } else {
            return this.interactions.onPlannedInvestimentCloseAttempt(this.instrument.typeMarket)
                .then((result) => {
                    if (result.confirm) {
                        this.marketOpen = result.market.marketOpen;
                        this.marketoOpeningTime = result.market.openingTime;
                        this.openDoneConfirmationDialog();
                    }
                });
        }
    }

    /**
     * Modal: Encerrar
     * Esse modal abre qual for clicado no botão de 'Encerrar'.
     */
    public openDoneConfirmationDialog() {
        const settings = new DialogDoneConfirmation(
            this.stockDetails.strategyID,
            this.symbol,
            this.instrument.descriptionStock,
            this.amount,
            this.legInput.avaragePriceExecuted,
            this.instrument.typeMarket,
            this.legInput.side,
            this.stress,
            this.instrument.quoteFactor,
            this.legStopLoss.priceTrigger,
            this.isDaytrade,
            this.isPtax,
            this.instrument.brokerageFactor,
            this.secondaryStress,
            this.stockDetails.originType,
            this.marketOpen,
            this.marketoOpeningTime,
            'Meus investimentos',
        );
        this.closeInvestmentDialog = this.dialogsService.showComponentAsAsidePanel(DialogDoneConfirmationComponent, true, settings);

        const component = this.closeInvestmentDialog.componentInstance as DialogDoneConfirmationComponent;
        component.onClosing$.subscribe((closing) => {
            this.closingRequested = closing;
        });
    }

    public goToStockTracking() {
        if (this.pending) {
            // tslint:disable-next-line: prefer-const
            let item = new StockCheckoutType();
            item.strategyId = this.stockDetails.strategyID;
            item.symbol = this.symbol;
            this.store.dispatch({ type: StocksExchangeCheckoutAction.setStockCheckout, payload: item });
            this.router.navigate(['/checkout/planejado/editar']);
        } else {
            this.router.navigate(['/acompanhamento/planejado/', this.stockDetails.strategyID]);
        }
    }

    private isPendingStatus(status: OrderStatus) {
        switch (status) {
            case OrderStatus.PendingNewRisk:
            case OrderStatus.PendingNewExchange:
            case OrderStatus.PendingNewTradeConnector:
            case OrderStatus.ScheduledNew:
            case OrderStatus.ScheduledReplacement:
            case OrderStatus.PendingReplaceRisk:
            case OrderStatus.PendingReplaceExchange:
            case OrderStatus.PendingReplaceTradeConector:
                return true;
            default:
                return false;
        }
    }

    private cancelStrategy() {
        this.onLoading.emit(true);
        // ToDo: Review algo
        this.store.dispatch({ type: ExchangeActions.cancelStrategy, payload: { orderId: this.stockDetails.strategyID } });
        const side = (this.isBuy) ? 'compra' : 'venda';

        this.cancelStrategySuccessSubsctiption = this.exchangeEffects.cancelStrategy$.pipe(
            filter((item) => item.type.equals(ExchangeActions.cancelStrategySuccess))
        ).subscribe((data) => {
            this.onLoading.emit(false);
            this.onHide.emit(true);
            this.showToastCancelSuccess(side);
        });

        this.cancelStrategyErrorSubsctiption = this.exchangeEffects.cancelStrategy$.pipe(
            filter((item) => item.type.equals(ExchangeActions.cancelStrategyError))
        ).subscribe((result) => {
            this.onLoading.emit(false);
            this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: result });
        });
    }

    private showToastCancelSuccess(side: string) {
        this.toastrService.success(
            `Você cancelou o seu pedido de ${side}`, '', {
            timeOut: 7000,
            progressBar: true,
            positionClass: 'toast-bottom-center',
            toastClass: 'toast--default font-small--medium font-light-color',
        },
        );
    }

    /**
     * Tracking de evento que informa que não foi possível carregar o card
     */
    private trackUnableToLoadCardEvent() {
        const cardInfo = {
            type: 'Unable to compute values',
            instrument: this.instrument,
            details: this.stockDetails,
            quote: this.quote,
        };
        // Enviar para o segment
        this.store.dispatch({
            type: TrackingActions.trackEvents,
            payload: {
                type: 'Investment not loaded',
                events: cardInfo,
            },
        });
    }
}
